import React, { useState } from "react";
import "./InterviewsBoxes.scss";
import { playIconGreen } from "../../source";
import { useWindowSize } from "react-use";

const InterviewsBoxes = ({ boxesData, video }) => {
  const { width } = useWindowSize();

  const [isExpanded, setIsExpanded] = useState({});

  const handleReadMore = (index) => {
    setIsExpanded((prev) => ({ ...prev, [index]: !prev[index] }));
  };

  const getDescription = (item, index) => {
    if (item.desc.length <= 90) {
      return item.desc;
    }

    if (isExpanded[index]) {
      return `${item.desc} <br><strong class="read_more">Read Less</strong>`;
    } else {
      return `${item.desc.slice(
        0,
        90
      )}... <br><strong class="read_more">Read More</strong>`;
    }
  };

  return (
    <>
      <div className="row interview_box_row">
        {boxesData.length === 0 ? (
          <div className="no-data-found">No data found</div>
        ) : (
          boxesData.map((item, i) => (
            <div
              className="col-md-6 interview_box_col"
              key={i}
              id={`interview-${i}`}
              data-aos="fade-up"
            >
              <div className="box">
                {item.type === "video" ? (
                  <div
                    className="img_wrapper"
                    style={{
                      cursor: "pointer",
                    }}
                    onClick={() => video(item.video)}
                  >
                    <img src={playIconGreen} alt="play icon" className="play_icon" />
                    <img
                      src={width <= 767 && item.mbImg ? item.mbImg : item.img}
                      alt={item.alt}
                      className="boxes_img"
                      width={width > 767 ? 536 : 686}
                      height={width > 767 ? 600 : 436}
                    />
                  </div>
                ) : (
                  <div className="img_wrapper">
                    <img
                      src={width <= 767 && item.mbImg ? item.mbImg : item.img}
                      alt={item.alt}
                      className="boxes_img"
                    />
                  </div>
                )}
                <h2
                  className="box_title"
                  dangerouslySetInnerHTML={{ __html: item.title }}
                ></h2>
                <p
                  className="section_desc20"
                  dangerouslySetInnerHTML={{
                    __html: getDescription(item, i),
                  }}
                  onClick={(e) => {
                    if (e.target.classList.contains("read_more")) {
                      handleReadMore(i);
                    }
                  }}
                ></p>
              </div>
            </div>
          ))
        )}
      </div>
    </>
  );
};

export default InterviewsBoxes;
